module.exports = new __parcel__URL__("machines_laser_cannon_level_1.a58ee437.png").toString();